/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { withStyles } from '@material-ui/core/styles'
import { visuallyHidden } from '@mui/utils'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { Check, HelpCircle, Info } from 'react-feather'
import { useTranslation } from 'react-i18next'
import SignatureCanvas from 'react-signature-canvas'

import { CoreSchema } from '../../../../../../clientFiles/validations'
import { PROGRAM_TYPE } from '../../../../../helpers/constants'
import { specialStudentOPtions } from '../../../../../helpers/stub'
import { isEmpty, noop } from '../../../../../helpers/utils'
import CustomDialog from '../../../../common/CustomDialog'
import LoaderButton from '../../../../common/LoaderButton'
import useStyles from '../../allEnrollments/ProgramCourses.Style'

function TermsConditions({
  open,
  onClose,
  enrollCourse,
  termCondition,
  school,
  programDetail,
  selectedGrade,
  selectedGradeAddOnProgram,
}) {
  const classes = useStyles()
  const { t } = useTranslation()
  const signRef = React.useRef(null)
  const initialState = React.useRef({
    is_iep: 'no',
    last_grade: '',
    signature: '',
    current_grade: '',
    tncAccepted: false,
    pgm_is_college_program: false,
  })

  React.useEffect(() => {
    if (!isEmpty(programDetail)) {
      initialState.current = {
        ...initialState.current,
        pgm_is_college_program: programDetail.pgm_is_college_program,
      }
    }
  }, [programDetail])

  const onSubmit = function (values, { setErrors }) {
    if (signRef.current.isEmpty()) {
      return setErrors({ signature: 'error:errorSignatureRequired' })
    }
    if (
      values.current_grade === '' &&
      (programDetail.pgm_program_type === PROGRAM_TYPE.LIBRARY ||
        !programDetail.pgm_course_required ||
        programDetail.pgm_courseless)
    ) {
      return setErrors({ current_grade: 'error:errorCurrentGrade' })
    }
    const updatedValues = {
      is_iep: values.is_iep,
      last_grade: values.last_grade,
      current_grade: isEmpty(selectedGrade) ? values.current_grade : selectedGrade,
      add_on_program_grade: isEmpty(selectedGradeAddOnProgram)
        ? values.current_grade
        : selectedGradeAddOnProgram,

      tncAccepted: values.tncAccepted,
    }
    enrollCourse({ ...updatedValues, signature: signRef.current.toDataURL() }, { setErrors })
  }

  const onClear = function () {
    signRef.current.clear()
  }

  const CheckboxWithGreenCheck = withStyles({})(Checkbox)
  return (
    <CustomDialog
      paper="true"
      className="custom-dialog"
      close={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth="md"
    >
      <Formik
        onSubmit={onSubmit}
        initialValues={initialState.current}
        enableReinitialize={true}
        validationSchema={CoreSchema.enrollmentTnCForm}
      >
        {({ values, setFieldValue }) => {
          return (
            <Form className={classes.form} noValidate autoComplete="off">
              <DialogTitle disableTypography id="customized-dialog-title" onClose={onClose}>
                <Typography variant="h5" tabIndex={0}>
                  <Box pt={1} fontWeight={700}>
                    {t('termsConditions')}
                  </Box>
                </Typography>
              </DialogTitle>

              <DialogContent>
                <Box width="100%" style={{ overflow: 'hidden', height: '100%', width: '100%' }}>
                  <Box width="100%" mb={3} className="dark-box" p={1}>
                    <Box
                      mb={2}
                      color="var(--color-grey-1)"
                      component="div"
                      fontWeight={500}
                      lineHeight="24px"
                      dangerouslySetInnerHTML={{
                        __html: termCondition,
                      }}
                    ></Box>
                  </Box>

                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={6}>
                      <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
                        <Box component="span" fontWeight="600">
                          {t('fields:specialEducation')}
                        </Box>
                        <Box component="span" className="mandatory">
                          {t('fields:mandatory')}
                        </Box>
                      </Typography>
                      <Field
                        className={classes.selectIcon + ' custom-input-field'}
                        name="is_iep"
                        as={TextField}
                        variant="outlined"
                        fullWidth
                        size="small"
                        id="is_iep"
                        pr={0}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Tooltip title={t('fields:specialEducationHelp')} placement="top">
                                <HelpCircle className="help-icon" />
                              </Tooltip>
                            </InputAdornment>
                          ),
                        }}
                        label={
                          <span style={visuallyHidden}>
                            {t('fields:specialEducation')} ({t('fields:mandatory')}) (
                            {t('fields:specialEducationHelp')}
                          </span>
                        }
                        select
                      >
                        {specialStudentOPtions.map((item) => (
                          <MenuItem key={item} value={item}>
                            {t(item)}
                          </MenuItem>
                        ))}
                      </Field>
                      <ErrorMessage name="is_iep">
                        {(msg) => (
                          <span className="error" tabIndex={0}>
                            {t(msg, { field: t('fields:specialEducation') })}
                          </span>
                        )}
                      </ErrorMessage>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
                        <Box component="span" fontWeight="600">
                          {t('fields:lastGradeCompleted')}
                        </Box>
                        <Box component="span" className="optional">
                          ({t('fields:optional')})
                        </Box>
                      </Typography>
                      <Field
                        className="custom-input-field"
                        name="last_grade"
                        as={TextField}
                        variant="outlined"
                        fullWidth
                        size="small"
                        id="last_grade"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Tooltip title={t('fields:lastGradeCompletedHelp')} placement="top">
                                <HelpCircle className="help-icon" />
                              </Tooltip>
                            </InputAdornment>
                          ),
                        }}
                        label={
                          <span style={visuallyHidden}>
                            {t('fields:lastGradeCompleted')} ({t('fields:mandatory')}) (
                            {t('fields:lastGradeCompletedHelp')}
                          </span>
                        }
                      />
                      <ErrorMessage name="last_grade">
                        {(msg) => (
                          <span className="error" tabIndex={0}>
                            {t(msg, { field: t('fields:lastGradeCompleted') })}
                          </span>
                        )}
                      </ErrorMessage>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
                        <Box component="span" fontWeight="600">
                          {t('fields:signature')}
                        </Box>
                        <Box component="span" className="mandatory">
                          {t('fields:mandatory')}
                        </Box>
                      </Typography>
                      <Box display="flex" alignItems="center" mt={1} mb={1}>
                        <Box mr={1} color="var(--color-grey-5)">
                          <Info width={16} height={16} />
                        </Box>
                        <Box
                          mb={0.5}
                          color="var(--color-secondary-text)"
                          fontStyle="italic"
                          fontSize="12px"
                          fontWeight={500}
                        >
                          {t('signatureInfo')}
                        </Box>
                      </Box>

                      <Box
                        width="100%"
                        display="flex"
                        alignItems={{ xs: 'flex-start', sm: 'flex-end' }}
                        justifyContent="flex-start"
                        flexDirection={{ xs: 'column', sm: 'column', lg: 'row' }}
                        className="sigContainer"
                      >
                        <Box
                          display="flex"
                          width="100%"
                          justifyContent="flex-start"
                          flexDirection="column"
                        >
                          <SignatureCanvas
                            width="100%"
                            ref={signRef}
                            canvasProps={{ className: 'sigPad' }}
                          />
                          <ErrorMessage name="signature">
                            {(msg) => (
                              <span className="error" tabIndex={0}>
                                {t(msg, { field: t('fields:signature') })}
                              </span>
                            )}
                          </ErrorMessage>
                        </Box>
                        <Box ml={{ xs: 0, sm: 1 }} mt={{ xs: 2, sm: 2 }}>
                          <Button
                            className="text-transform-none"
                            variant="text"
                            disableElevation
                            color="default"
                            onClick={onClear}
                          >
                            {t('clear')}
                          </Button>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      {(programDetail.pgm_program_type === PROGRAM_TYPE.LIBRARY ||
                        !programDetail.pgm_course_required ||
                        programDetail.pgm_courseless) && (
                        <Grid item xs={12} sm={12} md={12}>
                          <Typography
                            component="p"
                            variant="body2"
                            color="textPrimary"
                            gutterBottom
                          >
                            <Box component="span" fontWeight="600">
                              {t('fields:currentGradeLevel')}
                            </Box>
                            <Box component="span" className="mandatory">
                              {t('fields:mandatory')}
                            </Box>
                          </Typography>
                          <Field
                            className={classes.selectIcon + ' custom-input-field'}
                            name="current_grade"
                            as={TextField}
                            variant="outlined"
                            fullWidth
                            size="small"
                            id="current_grade"
                            pr={0}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Tooltip
                                    title={t('fields:currentGradeLevelHelp')}
                                    placement="top"
                                  >
                                    <HelpCircle className="help-icon" />
                                  </Tooltip>
                                </InputAdornment>
                              ),
                            }}
                            label={
                              <span style={visuallyHidden}>
                                {t('fields:currentGradeLevel')} ({t('fields:mandatory')}) (
                                {t('fields:currentGradeLevelHelp')}
                              </span>
                            }
                            select
                          >
                            {programDetail?.pgm_grade_level?.map((item) => (
                              <MenuItem key={item} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Field>
                          <ErrorMessage name="current_grade">
                            {(msg) => (
                              <span className="error" tabIndex={0}>
                                {t(msg, { field: t('fields:currentGradeLevel') })}
                              </span>
                            )}
                          </ErrorMessage>
                        </Grid>
                      )}
                      <Grid item xs={12} sm={12} md={12}>
                        <Box pl={1} mt={{ xs: 0, sm: 5 }} className="custom-checkbox">
                          <FormControlLabel
                            control={
                              <CheckboxWithGreenCheck
                                checked={values.tncAccepted}
                                onChange={(e) => setFieldValue('tncAccepted', e.target.checked)}
                                checkedIcon={<Check />}
                                color="primary"
                              />
                            }
                            label={t('fields:agreement', {
                              schoolName: school.sch_name,
                            })}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </DialogContent>
              <DialogActions>
                <Button
                  className="custom-default-button text-transform-none"
                  size="large"
                  variant="contained"
                  disableElevation
                  color="default"
                  onClick={onClose}
                >
                  {t('cancel')}
                </Button>
                <LoaderButton
                  className="text-transform-none"
                  size="large"
                  variant="contained"
                  disableElevation
                  color="primary"
                  disabled={!values.tncAccepted}
                  type="submit"
                >
                  {t('submitContinue')}
                </LoaderButton>
              </DialogActions>
            </Form>
          )
        }}
      </Formik>
    </CustomDialog>
  )
}

TermsConditions.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  enrollCourse: PropTypes.func,
  termCondition: PropTypes.string,
  school: PropTypes.object,
  programDetail: PropTypes.object,
  selectedGrade: PropTypes.string,
  selectedGradeAddOnProgram: PropTypes.string,
}

TermsConditions.defaultProps = {
  open: false,
  onClose: noop,
  enrollCourse: noop,
  termCondition: '',
  school: {},
  programDetail: {},
  selectedGrade: '',
  selectedGradeAddOnProgram: '',
}

export default TermsConditions
